import React, { useState } from "react";

const Team = () => {
  const [showMore, setShowMore] = useState("");

  function toggleShowMore(Qindex) {
    setShowMore(Qindex);
  }

  return (
    <div
      className="team container-fluid bg-white row"
      style={{ margin: "auto" }}
    >
      <p>
        <h1>Our Team</h1>
      </p>
      <div class="card m-3">
        <img
          src="/images/1.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">
            Fauziyya Kabir Tukur – Managing Director, Mata Media
          </h5>
          <p
            class={` card-text story-para ${
              showMore === "1" ? "expanded" : "collapsed"
            }`}
          >
            Fauziyya is an award-winning journalist, information integrity
            specialist and media trainer with over a decade of experience in
            digital and investigative journalism. Her work sits at the
            intersection of digital safety, evidence-based storytelling and AI
            innovations in journalism. She spent several years at BBC News,
            where she led high-impact investigations into disinformation
            campaigns using advanced OSINT, forensic verification and digital
            analysis techniques. Her reporting uncovered coordinated influence
            operations around elections, identity-based misinformation,
            conspiracy networks and foreign propaganda targeting African
            audiences. This work has positioned her as one of Nigeria’s leading
            experts on the real-world impact of false information. She has
            trained journalists and communicators across Nigeria, Europe, Latin
            America, the United States and Asia on how to recognise, investigate
            and counter false information and the use of AI in media. Fauziyya
            is a co-founder of Mata Media Organisation, a pioneering women-led
            newsroom and the first of its kind in northern Nigeria—a region
            where women face significant structural and socio-cultural barriers
            to participation in the media. She has worked with global brands
            such as Google, Deutsche Welle and the World Press Institute.
            Fauziyya holds a master's degree in Media, Communication and
            Development from the London School of Economics and Political
            Science.
          </p>
          <b
            onClick={() => toggleShowMore("1")}
            style={
              showMore === "1" ? { display: "none" } : { display: "block" }
            }
            className="show"
          >
            Show more
          </b>
          <b
            onClick={() => toggleShowMore("0")}
            style={
              showMore !== "1" ? { display: "none" } : { display: "block" }
            }
            className="show"
          >
            Show less
          </b>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 13.50.26.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">Hafsat Bahara - Editor – Mata Media</h5>
          <p
            class={` card-text story-para ${
              showMore === "2" ? "expanded" : "collapsed"
            }`}
          >
            Hafsat Bahara is an award-winning investigative journalist who
            currently serves as Editor at Mata Media. She has over five years of
            experience in Nigeria’s media industry and has worked with prominent
            organizations across diverse mediums,including the Nigerian
            Television Authority (NTA), Abubakar Rimi Television (ARTV), Premier
            Radio, LEADERSHIP Newspaper, and the Wole Soyinka Centre for
            Investigative Journalism, earning recognition for her investigative
            reporting and newsroom leadership. She is also a Mass Communication
            lecturer and a prestigious fellow of programs such as the Baobab for
            Women’s Human Rights SGBV Fellowship and the Digital Rights
            Fellowship. Hafsat is currently pursuing doctoral research on the
            use of social media by bandits in Nigeria, reflecting her commitment
            to addressing critical national issues through journalism.
          </p>
          <b
            onClick={() => toggleShowMore("2")}
            style={
              showMore === "2" ? { display: "none" } : { display: "block" }
            }
            className="show"
          >
            Show more
          </b>
          <b
            onClick={() => toggleShowMore("0")}
            style={
              showMore !== "2" ? { display: "none" } : { display: "block" }
            }
            className="show"
          >
            Show less
          </b>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 14.16.23.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">
            Hussaina Mukhtar Muhammad - Graphic Designer
          </h5>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 15.46.57.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">
            Aishatu Dan Idi Maikwano – Reporter/Video Editor - Kano{" "}
          </h5>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 14.17.07.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">
            Khadijah Nasidi - Freelance Reporter (Kano and Abuja){" "}
          </h5>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 14.19.22.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">
            Amammata Isah – Videographer (Abuja/Kaduna){" "}
          </h5>
        </div>
      </div>

      <div class="card  m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 14.20.44.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">
            Zakiyya Al-Amin Freelance Videographer – (Bauchi/Gombe){" "}
          </h5>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 14.43.01.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">Hafsah AB Hamza - Podcast Presenter </h5>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 15.45.42.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">Sakina Muhammad Yazid – Podcast Presenter </h5>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-02 at 16.23.42.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">Fatima Zahra Tabi'u – Podcast Presenter </h5>
        </div>
      </div>

      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-03 at 04.36.09.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">Halima Wada Sinkin - Reporter Kano</h5>
        </div>
      </div>
      <div class="card m-3">
        <img
          src="/images/WhatsApp Image 2026-04-03 at 11.34.26.jpeg"
          class="card-img-top"
          alt="..."
          className="teamimg"
        />
        <div class="card-body">
          <h5 class="card-title">Khadija Ahmad Salihu - Reporter Bauchi</h5>
        </div>
      </div>
    </div>
  );
};

export default Team;
